module.exports = __webpack_public_path__ + "img/pr-51.f2f9fc36.png";